module.exports = __webpack_public_path__ + "static/media/logo-bling-v3.3a19a135.svg";